var hacker = {};
module['exports'] = hacker;
hacker.abbreviation = require("./abbreviation");
hacker.adjective = require("./adjective");
hacker.noun = require("./noun");
hacker.verb = require("./verb");
hacker.ingverb = require("./ingverb");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/hacker/index.js
// module id = 389
// module chunks = 0